<div class="twitch-player-container" #twitchPlayerContainer>
  <div [id]="playerId"></div>
</div>
